'use client';

import * as React from 'react';
import { useWaiterRouter } from '../hooks/useWaiterRouter';

/**
 * Component that, when rendered, redirects the user to the provided screen.
 * Uses the `router.replace` method.
 */
export var Redirect = function Redirect(_ref) {
  var to = _ref.to,
      options = _ref.options;
  var router = useWaiterRouter();
  React.useEffect(function () {
    router.replace(to, options);
  }, [options, router, to]);
  return null;
};